import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import PdvView from '../views/PdvView.vue'
import StockView from '../views/StockView.vue'
import { useAuth } from '@/services/auth'

const routes = [
  { path: '/', name: 'home', component: LoginView,
    meta: { title: 'Login', }},
  { path: '/pdv', name: 'pdv', component: PdvView,
    meta: { title: 'PDV', auth: true, op: 'operador' }},
  { path: '/estoque', name: 'estoque', component: StockView,
    meta: { title: 'Estoque', auth: true, op: 'operador' }},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta?.auth) {
    const oplevel = to.meta?.op;
    const auth = useAuth();
    if (auth.token && auth.token) {
      const isAuthenticated = await auth.checkAuth(oplevel);
      if (isAuthenticated) {
        // Operador sem permissão de vender não abre caixa — a tela de
        // venda não existe pra ele, então acessar /pdv direto pela URL
        // (bookmark, digitação manual) cai na tela de estoque em vez de
        // dar 422 tentando currentCashier() na primeira ação.
        if (to.name === 'pdv' && !auth.canMakeSale) {
          next({ name: 'estoque' });
          return;
        }
        next();
      } else {
        next({name:'home'});
      }
    } else {
      next({name:'home'});
    }
  } else {
    next()
  }
  document.title = to.meta.title + ' - LC3 Market' || 'LC3 Market';
});

export default router
